/**
 * Narrow an `unknown` to a `string`, falling back to `null` for any non-string
 * input (including `undefined`, numbers, booleans, objects). Used at component
 * boundaries where loosely-typed external state (RStore form objects, JSON
 * envelopes) flows into a strictly-typed `string | null` prop.
 */
export function asStringOrNull(value: unknown): string | null {
	return typeof value === 'string' ? value : null;
}

/**
 * Narrow an `unknown` to a trimmed `string`, collapsing blank input to `null`.
 * Non-string input (including `undefined`) and strings that are empty after
 * trimming both yield `null`. Used where form state writes optional text fields
 * that the wire envelope expects as `string | null`.
 */
export function blankToNull(value: unknown): string | null {
	if (typeof value !== 'string') return null;
	const trimmed = value.trim();
	return trimmed === '' ? null : trimmed;
}
